import { useEffect, useState, useCallback } from "react";
import "./joining-requests.css";
import { capitalize, isEmpty, wait } from "../../../../../core/utils/helpers";
import { FcApproval, FcDisapprove } from "react-icons/fc";
import { IoIosRefreshCircle } from "react-icons/io";
import Swal from "sweetalert2";
import moment from "moment";
//
import {
  onGetChallengeJoiningRequestsByChallengeId,
  onProcessChallengeJoiningRequest,
  onProcessRevokeChallengeJoiningRequest,
} from "../../../services/challenge";
import { socketIo } from "../../../../../core/socket/socket-client";
import NotFound from "../../../../../ui/organisms/not-found/404";
import useAxiosPrivate from "../../../../../app/providers/context-provider/useAxiosPrivate";

const JoiningRequests = ({ challenge_id, inscription_id }) => {
  const axiosPrivate = useAxiosPrivate();

  const [isSending, setIsSending] = useState(false);
  const [requestsJoining, setRequestsJoining] = useState([]);

  useEffect(() => {
    onRefreshRequests();
  }, []);

  useEffect(() => {
    socketIo.emit("authenticate", { inscription_id: inscription_id });

    const onHandleNewRequest = (data) => {
      if (data?.status) onRefreshRequests();
    };

    const onHandleNewRequestState = (data) => {
      if (data?.status) onRefreshRequests();
    };

    socketIo.on("on_new_request_joining_challenge", onHandleNewRequest);
    socketIo.on(
      "on_request_joining_challenge_process_state",
      onHandleNewRequestState,
    );

    return () => {
      socketIo.off("on_new_request_joining_challenge", onHandleNewRequest);
      socketIo.off(
        "on_request_joining_challenge_process_state",
        onHandleNewRequestState,
      );
    };
  }, []);

  const onRefreshRequests = useCallback(() => {
    const localData = { challenge_id };
    onGetChallengeJoiningRequestsByChallengeId(axiosPrivate, localData)
      .then((response) => {
        const _data = response?.data;
        setRequestsJoining(_data);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || "An error occurred",
        });
      });
  }, [challenge_id]);

  const onHandleProcessRequest = async (request_id, is_authorized) => {
    setIsSending(true);
    await wait(200);
    //
    const local_data = {
      request_id: request_id,
      is_authorized: is_authorized,
      process_request_dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    onProcessChallengeJoiningRequest(axiosPrivate, local_data)
      .then((response) => {
        const _data = response?.data;
        setIsSending(false);
        if (_data?.status) {
        } else {
          Swal.fire({
            icon: "warning",
            title: "Request Joining Challenge",
            text: _data?.message || "The request was Denied.",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error.response.data?.message || "An error occurred",
          });
        }
      });
  };

  const onHandleRevokeRequest = async (request_id) => {
    setIsSending(true);
    await wait(200);
    //
    const local_data = {
      request_id: request_id,
      process_request_dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    onProcessRevokeChallengeJoiningRequest(axiosPrivate, local_data)
      .then((result) => {
        const _data = result?.data;
        setIsSending(false);
        if (_data?.status) {
        } else {
          Swal.fire({
            icon: "warning",
            title: "Request Joining Challenge",
            text:
              _data?.message ||
              "An error occurred in the server. Please try again.",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error.response.data?.message || "An error occurred",
          });
        }
      });
  };

  return (
    <div className="joining-requests">
      {isEmpty(requestsJoining?.result) ? (
        <NotFound
          type={"data"}
          title={"No Challenge Joining Request found!"}
          text={requestsJoining?.message}
          isBoutton={false}
        />
      ) : (
        requestsJoining?.result?.map((request, index) => {
          const start = moment(request?.dates);
          const end = moment(new Date());
          const minutes = end.diff(start, "minutes");

          return (
            <div
              className={
                isEmpty(request?.is_authorized)
                  ? "jr-item is-pending-request"
                  : "jr-item"
              }
              key={index}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <div className="jr-item-wrapper">
                <div className="jr-i-profile">
                  <img
                    src={process.env.PUBLIC_URL + "/user.png"}
                    alt="challenge pamoja for machine intelligence university"
                  />
                  <h1>{`${capitalize(request?.user_firstname)} ${capitalize(
                    request?.user_lastname,
                  )}`}</h1>
                </div>
                <div className="jr-i-actions">
                  {isEmpty(request?.is_authorized) && (
                    <>
                      <button
                        className="button eject"
                        onClick={() =>
                          onHandleProcessRequest(
                            request?.joined_challenge_id,
                            false,
                          )
                        }
                      >
                        Reject
                      </button>
                      <button
                        className="button accepted"
                        onClick={() =>
                          onHandleProcessRequest(
                            request?.joined_challenge_id,
                            true,
                          )
                        }
                      >
                        Accept
                      </button>
                    </>
                  )}
                  {request?.is_authorized === true && (
                    <>
                      <FcApproval className="icon" />
                      <span className="span-status approved">
                        request approved!
                      </span>
                      <span
                        className="span-button"
                        onClick={() =>
                          onHandleRevokeRequest(request?.joined_challenge_id)
                        }
                      >
                        <IoIosRefreshCircle className="icon" />
                      </span>
                    </>
                  )}
                  {request?.is_authorized === false && (
                    <>
                      <FcDisapprove className="icon" />
                      <span className="span-status disapproved">
                        request disapproved!
                      </span>
                      <span
                        className="span-button"
                        onClick={() =>
                          onHandleRevokeRequest(request?.joined_challenge_id)
                        }
                      >
                        <IoIosRefreshCircle className="icon" />
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default JoiningRequests;
